import { Link, useNavigate, useParams } from "react-router-dom";
import { useState, useEffect, useRef } from "react";
import axios from 'axios';
import config from "../../Common/Configurations/APIConfig";
import { handleSuccess, handleError } from "../../Common/Layout/CustomAlerts";
import Header from "../../Common/Layout/Header";
import SideBar from "../../Common/Layout/Sidebar";
import moment from "moment";
import UserTab from "./UserTab";
const initialFieldValues = {
    clientDocumentId: "00000000-0000-0000-0000-000000000000",
    lendingApplicationId: "00000000-0000-0000-0000-000000000000",
    userId: "00000000-0000-0000-0000-000000000000",
    documentType: "BankStatement",
    imageFile: null,
    imageSrc: ''
};
export default function ClientDocuments(props) {
    const navigate = useNavigate();
    const params = useParams();
    const [loading, setLoading] = useState(false);
    const [values, setValues] = useState(initialFieldValues);
    const [errors, setErrors] = useState({});
    const [documents, setDocuments] = useState([]);
    const [selectedFile, setSelectedFile] = useState(null);
    const [scoreCard, setScorecard] = useState([])
    const [selectedFiles, setSelectedFiles] = useState([]);
    const [refreshKey, setRefreshKey] = useState(0);
    const headerconfig = {
        headers: {
            Authorization: "Bearer " + localStorage.getItem("userToken")
        }
    }
    const fileInputRef = useRef(null);
    const handleClick = () => {
        if (fileInputRef.current) {
            fileInputRef.current.click();
        }
    };
    const handleInputChange = (e) => {
        const files = Array.from(e.target.files);
        if (files && files.length > 0) {
            setSelectedFiles(files);
            handleSubmit(files);
        }
    };
    const validate = () => {
        let temp = {};
        temp.imageSrc = values.imageSrc === "" ? false : true;
        setErrors(temp);
        return Object.values(temp).every((x) => x === true);
    };
    const handleSubmit = (selectedFiles) => {
        //e.preventDefault();
        setLoading(true);
        const formData = new FormData()
        formData.append("clientDocumentId", values.clientDocumentId)
        formData.append("userId", localStorage.getItem("userId"))
        formData.append("clientId", localStorage.getItem("clientId"))
        formData.append("documentType", values.documentType)
        formData.append("lendingApplicationId", params.lendingApplicationId)
        //formData.append("imageFile", imageFile)
        selectedFiles.forEach(file => {
            formData.append("imageFiles", file); // must match backend model name
        });
        addOrEdit(formData);
    }
    const applicationAPI = () => {
        return {
            create: (newrecord) =>
                axios.post(config.APIACTIVATEURL + config.CREATECLIENTDOCUMENT, newrecord, { ...headerconfig })
        };
    };
    const addOrEdit = (formData) => {
        if (formData.get('clientDocumentId') === "00000000-0000-0000-0000-000000000000") {
            applicationAPI()
                .create(formData)
                .then((res) => {
                    if (res.data.statusCode === 200) {
                        handleSuccess("Document Uploaded");
                        resetForm();
                        setLoading(false);
                        GetUserDocuments();
                        setRefreshKey((prevKey) => prevKey + 1); // Triggers re-render
                    }
                    else {
                        handleError(res.data.message);
                        setLoading(false);
                    }
                })
                .catch(function (error) {
                    handleError("Error in saving data");
                    setLoading(false);
                });
        }
    };
    const resetForm = () => {
        setValues(initialFieldValues);
        setErrors({});
        setSelectedFile(null);
    };
    const onDelete = (e, id) => {
        if (window.confirm('Are you sure to delete this record?')) {
            axios.delete(config.APIACTIVATEURL + config.DELETECLIENTDOCUMENT + "/" + id, { ...headerconfig })
                .then((response) => {
                    if (response.data.statusCode === 200) {
                        handleSuccess(response.data.message);
                        GetUserDocuments();
                    }
                    else {
                        handleError(response.data.message);
                        GetUserDocuments();
                    }
                });
        }
    }

    const GetUserDocuments = () => {
        axios.get(config.APIACTIVATEURL + config.GETCLIENTDOCUMENTS + "?Id=" + params.lendingApplicationId, { ...headerconfig })
            .then((response) => {
                if (response.data.statusCode === 200) {
                    setDocuments(response.data.data);
                    GetScoreCard();
                }
            });
    };
    const GetScoreCard = () => {
        axios.get(config.APIACTIVATEURL + config.GETSCORECARD + "/" + params.lendingApplicationId, { ...headerconfig })
            .then((response) => {
                if (response.data.statusCode === 200) {
                    if (response.data.data != null) {
                        var jsonData = response.data.data;
                        if (jsonData.result.revenueStatistics != null) {
                            setScorecard(jsonData.result.revenueStatistics);
                        }
                    }
                }
            });
    };
    const applyErrorClass = (field) => field in errors && errors[field] === false ? " form-control-danger" : "";
    useEffect(() => {
        GetUserDocuments();
    }, [])
    return (
        <div id="layout-wrapper">
            <Header key={refreshKey}></Header>
            <SideBar></SideBar>
            <div className="body-wrapper">
                <div className="container-fluid">
                    <div class="card card-body py-3">
                        <UserTab pagename="documents"></UserTab>
                    </div>
                    <div class="card card-body py-3">
                        <div className="row">
                            <div className="col-lg-6">
                                <form onSubmit={handleSubmit} autoComplete="off" noValidate>
                                    <div className="row justify-content-center text-center">
                                        <div className="dropzone mb-3" onClick={handleClick} style={{ cursor: loading ? "not-allowed" : "pointer" }}>
                                            <div className="fallback">
                                                <input ref={fileInputRef} multiple type="file" accept="application/pdf" onChange={handleInputChange} name="imageSrc" style={{ display: "none" }} />
                                            </div>
                                            <div className="dz-message needsclick">
                                                <div className="mb-3">
                                                    {loading ? <img src="/assets/images/uploadloading.gif" width="60px" height="60px"></img>
                                                        : <i className="display-4 text-muted ri-upload-cloud-2-fill"></i>}
                                                </div>
                                                <h4>{loading ? "Uploading... Please wait." : "Click here to upload bank statements."}</h4>
                                            </div>
                                        </div>
                                        {errors.imageSrc === false ? (<div className="validationerror">Please select the pdf file</div>) : ('')}                                        
                                    </div>
                                </form>
                            </div>
                            <div className="col-lg-6">
                                <div className="col-lg-12 mb-3">
                                    <h5 className="text-bg-primary p-3">Bank Statements</h5>
                                </div>
                                <div className="table-responsive">
                                    <table className="table table-borderless align-middle mb-0">
                                        <thead className="table-light">
                                            <tr>
                                                <th scope="col">File Name</th>
                                                <th scope="col">Upload Date</th>
                                                <th scope="col">Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {documents.length > 0 && documents.map(d =>
                                                <tr>
                                                    <td>
                                                        <div className="d-flex align-items-center">
                                                            <div className="avatar-sm">
                                                                <div className="avatar-title bg-soft-primary text-primary rounded fs-20">
                                                                    <i className="ri-file-zip-fill" />
                                                                </div>
                                                            </div>
                                                            <div className="ms-3 flex-grow-1 me-2">
                                                                <h6 className="fs-3 mb-0">{d.documentName}</h6>
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td>{moment.utc(d.createdDate).local().format("YYYY-MM-DD hh:mm a")}</td>
                                                    <td>
                                                        <ul className="list-inline hstack gap-2 mb-0">
                                                            <li className="list-inline-item" data-bs-toggle="tooltip" data-bs-trigger="hover" data-bs-placement="top" title="View">
                                                                <Link className="edit-item-btn" to={d.imageSrc} target="_blank"><i className="ri-eye-fill align-bottom text-muted" /></Link>
                                                            </li>
                                                            <li className="list-inline-item" data-bs-toggle="tooltip" data-bs-trigger="hover" data-bs-placement="top" title="Delete">
                                                                <Link className="remove-item-btn" onClick={e => onDelete(e, d.clientDocumentId)}>
                                                                    <i className="ri-delete-bin-fill align-bottom text-danger" />
                                                                </Link>
                                                            </li>
                                                        </ul>
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                    {documents.length>0?
                    <div class="card card-body py-3">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="container mx-auto p-4">
                                    <h4 className="text-xl font-bold mb-4">Revenue Statistics</h4>
                                    {scoreCard.length > 0 ?
                                        <table className="w-full table table-responsive border-collapse border border-gray-300">
                                            <thead>
                                                <tr className="bg-gray-200">
                                                    <th className="border border-gray-300 px-4 py-2 text-left">Label</th>
                                                    <th className="border border-gray-300 px-4 py-2 text-left">Monthly</th>
                                                    <th className="border border-gray-300 px-4 py-2 text-left">Annual</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {scoreCard.map((item, index) => (
                                                    <tr key={index} className="border border-gray-300">
                                                        <td className="border border-gray-300 px-4 py-2">{item.label}</td>
                                                        <td className="border border-gray-300 px-4 py-2">{item.monthly ?? "N/A"}</td>
                                                        <td className="border border-gray-300 px-4 py-2">{item.annual ?? "N/A"}</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                        :
                                        <div className="text-align-center">No records found. Please upload bank statements</div>}
                                </div>
                            </div>
                        </div>
                    </div>:""}
                </div>
            </div>
        </div>
    );
}